// @flow
import * as React from 'react';
import style from './style';
import virtaskLogo from './virtask.png';

const Logo = (): React.Element<any> => (
  <div style={style.logoStyle}>
    <img src={virtaskLogo} alt="Virtask" height="100%" />
  </div>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/scenes/Login/components/Logo/Logo.js